//
//
//
//
//
//
//
export default {
  name: 'MdmStripe',
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'small',

      validator(value) {
        return ['small', 'medium'].includes(value);
      }

    }
  },
  data: () => ({
    staticClass: {
      stripe: true,
      rounded: true
    }
  })
};